import React from 'react'

import { Box, useTheme } from '@material-ui/core'
import VirtualVisitInverted from '@scoir/brand-icons/dist/VirtualVisitInverted'
import { Tooltip } from '@scoir/tooltips'
import { get } from 'lodash'
import PropTypes from 'prop-types'

import './LocationSection.scss'
import { Section } from './OverlayParts'
import VirtualVisitLink from './VirtualVisitLink'

const Location = ({ isVirtual = false, registered, place }) => {
  const { palette } = useTheme()
  if (!place) {
    return 'TBD'
  }
  if (isVirtual) {
    if (registered) {
      return <VirtualVisitLink placename={place} />
    }
    return (
      <Tooltip title="Virtual meeting links are only available to users registered for the event">
        <Box
          display="inline-block"
          borderBottom={`1px dotted ${palette.grey[400]}`}
        >
          Launch Meeting &nbsp;
          <VirtualVisitInverted />
        </Box>
      </Tooltip>
    )
  }
  return place
}

Location.propTypes = {
  place: PropTypes.string,
  isVirtual: PropTypes.bool,
  registered: PropTypes.bool,
}

const LocationSection = ({ event, registered }) => {
  if (event.AllowRepLocationType && !registered) {
    return (
      <Section heading={'Where'}>
        <div className="event-location-section-comp">To be determined by the representative on registration.</div>
      </Section>
    )
  }
  const virtual = event.Virtual
  return (
    <Section heading={virtual ? 'Meeting Link' : 'Where'}>
      <div className="event-location-section-comp">
        <Location
          isVirtual={event.Virtual}
          registered={registered}
          place={get(event, 'Location.PlaceName')}
        />
      </div>
    </Section>
  )
}
LocationSection.propTypes = {
  event: PropTypes.shape({
    Location: PropTypes.object,
    Virtual: PropTypes.bool,
    Zoom: PropTypes.bool,
    ZoomJoinURL: PropTypes.string,
  }).isRequired,
  registered: PropTypes.bool,
}

export default LocationSection
